import DossierDashboard from "../components/dossierDashboard";

const Dashboard = () => {
    return <DossierDashboard />
};

export default Dashboard;
